import { render, staticRenderFns } from "./wizard-helpmenu.vue?vue&type=template&id=4a1a4061"
import script from "./wizard-helpmenu.vue?vue&type=script&lang=js"
export * from "./wizard-helpmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports